/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as adminRouteRouteImport } from './routes/(admin)/route'
import { Route as adminPageRouteImport } from './routes/(admin)/page'
import { Route as publicLandingRouteRouteImport } from './routes/(public)/landing/route'
import { Route as admin403PageRouteImport } from './routes/(admin)/403/page'
import { Route as adminAdminProfilePageRouteImport } from './routes/(admin)/admin-profile/page'
import { Route as adminAdminReportsPageRouteImport } from './routes/(admin)/admin-reports/page'
import { Route as adminAiOpsPageRouteImport } from './routes/(admin)/ai-ops/page'
import { Route as adminAnalyticsPageRouteImport } from './routes/(admin)/analytics/page'
import { Route as adminAnalyticsEcommerceRouteImport } from './routes/(admin)/analytics/ecommerce'
import { Route as adminAreasPageRouteImport } from './routes/(admin)/areas/page'
import { Route as adminAuditLogPageRouteImport } from './routes/(admin)/audit-log/page'
import { Route as adminBillingPageRouteImport } from './routes/(admin)/billing/page'
import { Route as adminBlogPageRouteImport } from './routes/(admin)/blog/page'
import { Route as adminBookingsPageRouteImport } from './routes/(admin)/bookings/page'
import { Route as adminCampaignsPageRouteImport } from './routes/(admin)/campaigns/page'
import { Route as adminCarouselPageRouteImport } from './routes/(admin)/carousel/page'
import { Route as adminCmsPageRouteImport } from './routes/(admin)/cms/page'
import { Route as adminContactsPageRouteImport } from './routes/(admin)/contacts/page'
import { Route as adminCrmPageRouteImport } from './routes/(admin)/crm/page'
import { Route as adminDiscountsPageRouteImport } from './routes/(admin)/discounts/page'
import { Route as adminHeroSlidesPageRouteImport } from './routes/(admin)/hero-slides/page'
import { Route as adminImageLibraryPageRouteImport } from './routes/(admin)/image-library/page'
import { Route as adminInventoryPageRouteImport } from './routes/(admin)/inventory/page'
import { Route as adminItemsPageRouteImport } from './routes/(admin)/items/page'
import { Route as adminLiveWorkforcePageRouteImport } from './routes/(admin)/live-workforce/page'
import { Route as adminLocationsPageRouteImport } from './routes/(admin)/locations/page'
import { Route as adminLoyaltyPageRouteImport } from './routes/(admin)/loyalty/page'
import { Route as adminMessagesPageRouteImport } from './routes/(admin)/messages/page'
import { Route as adminNewsletterPageRouteImport } from './routes/(admin)/newsletter/page'
import { Route as adminNotificationsPageRouteImport } from './routes/(admin)/notifications/page'
import { Route as adminOrdersPageRouteImport } from './routes/(admin)/orders/page'
import { Route as adminPackagesPageRouteImport } from './routes/(admin)/packages/page'
import { Route as adminPaymentsPageRouteImport } from './routes/(admin)/payments/page'
import { Route as adminPermissionsPageRouteImport } from './routes/(admin)/permissions/page'
import { Route as adminProductCampaignsPageRouteImport } from './routes/(admin)/product-campaigns/page'
import { Route as adminProductsPageRouteImport } from './routes/(admin)/products/page'
import { Route as adminPromoTilesPageRouteImport } from './routes/(admin)/promo-tiles/page'
import { Route as adminQuotesPageRouteImport } from './routes/(admin)/quotes/page'
import { Route as adminReferralsPageRouteImport } from './routes/(admin)/referrals/page'
import { Route as adminReportsPageRouteImport } from './routes/(admin)/reports/page'
import { Route as adminReviewsPageRouteImport } from './routes/(admin)/reviews/page'
import { Route as adminSchedulePageRouteImport } from './routes/(admin)/schedule/page'
import { Route as adminSettingsPageRouteImport } from './routes/(admin)/settings/page'
import { Route as adminSitePageRouteImport } from './routes/(admin)/site/page'
import { Route as adminSystemHealthPageRouteImport } from './routes/(admin)/system-health/page'
import { Route as adminTestimonialsPageRouteImport } from './routes/(admin)/testimonials/page'
import { Route as adminUsersPageRouteImport } from './routes/(admin)/users/page'
import { Route as adminWorkersPageRouteImport } from './routes/(admin)/workers/page'
import { Route as authenticationAuthPageRouteImport } from './routes/(authentication)/auth/page'
import { Route as authenticationAuthLayoutRouteImport } from './routes/(authentication)/auth/layout'
import { Route as authenticationAuthLogoutRouteImport } from './routes/(authentication)/auth/logout'
import { Route as publicLandingPageRouteImport } from './routes/(public)/landing/page'
import { Route as userDashboardPageRouteImport } from './routes/(user)/dashboard/page'
import { Route as userProfilePageRouteImport } from './routes/(user)/profile/page'
import { Route as adminothersPagesBlankPageRouteImport } from './routes/(admin)/(others-pages)/blank/page'
import { Route as adminothersPagesCalendarPageRouteImport } from './routes/(admin)/(others-pages)/calendar/page'
import { Route as adminBlogIdPageRouteImport } from './routes/(admin)/blog/$id/page'
import { Route as adminBlogNewPageRouteImport } from './routes/(admin)/blog/new/page'
import { Route as adminBookingsIdPageRouteImport } from './routes/(admin)/bookings/$id/page'
import { Route as adminCampaignsIdPageRouteImport } from './routes/(admin)/campaigns/$id/page'
import { Route as adminOrdersIdPageRouteImport } from './routes/(admin)/orders/$id/page'
import { Route as adminPlatformStoresPageRouteImport } from './routes/(admin)/platform/stores/page'
import { Route as adminProductsCategoriesPageRouteImport } from './routes/(admin)/products/categories/page'
import { Route as adminWorkersIdPageRouteImport } from './routes/(admin)/workers/$id/page'
import { Route as authenticationauthAcceptInvitePageRouteImport } from './routes/(authentication)/(auth)/accept-invite/page'
import { Route as authenticationauthForgotPasswordPageRouteImport } from './routes/(authentication)/(auth)/forgot-password/page'
import { Route as authenticationauthResetPasswordPageRouteImport } from './routes/(authentication)/(auth)/reset-password/page'
import { Route as authenticationauthSigninPageRouteImport } from './routes/(authentication)/(auth)/signin/page'
import { Route as authenticationauthSignupPageRouteImport } from './routes/(authentication)/(auth)/signup/page'
import { Route as authenticationerrorPagesError404PageRouteImport } from './routes/(authentication)/(error-pages)/error-404/page'
import { Route as adminothersPageschartBarChartPageRouteImport } from './routes/(admin)/(others-pages)/(chart)/bar-chart/page'
import { Route as adminothersPageschartLineChartPageRouteImport } from './routes/(admin)/(others-pages)/(chart)/line-chart/page'
import { Route as adminothersPagesformsFormElementsPageRouteImport } from './routes/(admin)/(others-pages)/(forms)/form-elements/page'
import { Route as adminothersPagestablesBasicTablesPageRouteImport } from './routes/(admin)/(others-pages)/(tables)/basic-tables/page'
import { Route as adminothersPagesuiElementsAlertsPageRouteImport } from './routes/(admin)/(others-pages)/(ui-elements)/alerts/page'
import { Route as adminothersPagesuiElementsAvatarsPageRouteImport } from './routes/(admin)/(others-pages)/(ui-elements)/avatars/page'
import { Route as adminothersPagesuiElementsBadgePageRouteImport } from './routes/(admin)/(others-pages)/(ui-elements)/badge/page'
import { Route as adminothersPagesuiElementsButtonsPageRouteImport } from './routes/(admin)/(others-pages)/(ui-elements)/buttons/page'
import { Route as adminothersPagesuiElementsImagesPageRouteImport } from './routes/(admin)/(others-pages)/(ui-elements)/images/page'
import { Route as adminothersPagesuiElementsModalsPageRouteImport } from './routes/(admin)/(others-pages)/(ui-elements)/modals/page'
import { Route as adminothersPagesuiElementsVideosPageRouteImport } from './routes/(admin)/(others-pages)/(ui-elements)/videos/page'
import { Route as authenticationauthPlatformSigninPageRouteImport } from './routes/(authentication)/(auth)/platform/signin/page'

const adminRouteRoute = adminRouteRouteImport.update({
  id: '/(admin)',
  getParentRoute: () => rootRouteImport,
} as any)
const adminPageRoute = adminPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => adminRouteRoute,
} as any)
const publicLandingRouteRoute = publicLandingRouteRouteImport.update({
  id: '/(public)/landing',
  path: '/landing',
  getParentRoute: () => rootRouteImport,
} as any)
const admin403PageRoute = admin403PageRouteImport.update({
  id: '/403/',
  path: '/403/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminAdminProfilePageRoute = adminAdminProfilePageRouteImport.update({
  id: '/admin-profile/',
  path: '/admin-profile/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminAdminReportsPageRoute = adminAdminReportsPageRouteImport.update({
  id: '/admin-reports/',
  path: '/admin-reports/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminAiOpsPageRoute = adminAiOpsPageRouteImport.update({
  id: '/ai-ops/',
  path: '/ai-ops/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminAnalyticsPageRoute = adminAnalyticsPageRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminAnalyticsEcommerceRoute = adminAnalyticsEcommerceRouteImport.update({
  id: '/analytics/ecommerce',
  path: '/analytics/ecommerce',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminAreasPageRoute = adminAreasPageRouteImport.update({
  id: '/areas/',
  path: '/areas/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminAuditLogPageRoute = adminAuditLogPageRouteImport.update({
  id: '/audit-log/',
  path: '/audit-log/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminBillingPageRoute = adminBillingPageRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminBlogPageRoute = adminBlogPageRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminBookingsPageRoute = adminBookingsPageRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminCampaignsPageRoute = adminCampaignsPageRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminCarouselPageRoute = adminCarouselPageRouteImport.update({
  id: '/carousel/',
  path: '/carousel/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminCmsPageRoute = adminCmsPageRouteImport.update({
  id: '/cms/',
  path: '/cms/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminContactsPageRoute = adminContactsPageRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminCrmPageRoute = adminCrmPageRouteImport.update({
  id: '/crm/',
  path: '/crm/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminDiscountsPageRoute = adminDiscountsPageRouteImport.update({
  id: '/discounts/',
  path: '/discounts/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminHeroSlidesPageRoute = adminHeroSlidesPageRouteImport.update({
  id: '/hero-slides/',
  path: '/hero-slides/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminImageLibraryPageRoute = adminImageLibraryPageRouteImport.update({
  id: '/image-library/',
  path: '/image-library/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminInventoryPageRoute = adminInventoryPageRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminItemsPageRoute = adminItemsPageRouteImport.update({
  id: '/items/',
  path: '/items/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminLiveWorkforcePageRoute = adminLiveWorkforcePageRouteImport.update({
  id: '/live-workforce/',
  path: '/live-workforce/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminLocationsPageRoute = adminLocationsPageRouteImport.update({
  id: '/locations/',
  path: '/locations/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminLoyaltyPageRoute = adminLoyaltyPageRouteImport.update({
  id: '/loyalty/',
  path: '/loyalty/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminMessagesPageRoute = adminMessagesPageRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminNewsletterPageRoute = adminNewsletterPageRouteImport.update({
  id: '/newsletter/',
  path: '/newsletter/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminNotificationsPageRoute = adminNotificationsPageRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminOrdersPageRoute = adminOrdersPageRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminPackagesPageRoute = adminPackagesPageRouteImport.update({
  id: '/packages/',
  path: '/packages/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminPaymentsPageRoute = adminPaymentsPageRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminPermissionsPageRoute = adminPermissionsPageRouteImport.update({
  id: '/permissions/',
  path: '/permissions/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminProductCampaignsPageRoute =
  adminProductCampaignsPageRouteImport.update({
    id: '/product-campaigns/',
    path: '/product-campaigns/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminProductsPageRoute = adminProductsPageRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminPromoTilesPageRoute = adminPromoTilesPageRouteImport.update({
  id: '/promo-tiles/',
  path: '/promo-tiles/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminQuotesPageRoute = adminQuotesPageRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminReferralsPageRoute = adminReferralsPageRouteImport.update({
  id: '/referrals/',
  path: '/referrals/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminReportsPageRoute = adminReportsPageRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminReviewsPageRoute = adminReviewsPageRouteImport.update({
  id: '/reviews/',
  path: '/reviews/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminSchedulePageRoute = adminSchedulePageRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminSettingsPageRoute = adminSettingsPageRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminSitePageRoute = adminSitePageRouteImport.update({
  id: '/site/',
  path: '/site/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminSystemHealthPageRoute = adminSystemHealthPageRouteImport.update({
  id: '/system-health/',
  path: '/system-health/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminTestimonialsPageRoute = adminTestimonialsPageRouteImport.update({
  id: '/testimonials/',
  path: '/testimonials/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminUsersPageRoute = adminUsersPageRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminWorkersPageRoute = adminWorkersPageRouteImport.update({
  id: '/workers/',
  path: '/workers/',
  getParentRoute: () => adminRouteRoute,
} as any)
const authenticationAuthPageRoute = authenticationAuthPageRouteImport.update({
  id: '/(authentication)/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
} as any)
const authenticationAuthLayoutRoute =
  authenticationAuthLayoutRouteImport.update({
    id: '/(authentication)/auth/layout',
    path: '/auth/layout',
    getParentRoute: () => rootRouteImport,
  } as any)
const authenticationAuthLogoutRoute =
  authenticationAuthLogoutRouteImport.update({
    id: '/(authentication)/auth/logout',
    path: '/auth/logout',
    getParentRoute: () => rootRouteImport,
  } as any)
const publicLandingPageRoute = publicLandingPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicLandingRouteRoute,
} as any)
const userDashboardPageRoute = userDashboardPageRouteImport.update({
  id: '/(user)/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const userProfilePageRoute = userProfilePageRouteImport.update({
  id: '/(user)/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const adminothersPagesBlankPageRoute =
  adminothersPagesBlankPageRouteImport.update({
    id: '/(others-pages)/blank/',
    path: '/blank/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPagesCalendarPageRoute =
  adminothersPagesCalendarPageRouteImport.update({
    id: '/(others-pages)/calendar/',
    path: '/calendar/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminBlogIdPageRoute = adminBlogIdPageRouteImport.update({
  id: '/blog/$id/',
  path: '/blog/$id/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminBlogNewPageRoute = adminBlogNewPageRouteImport.update({
  id: '/blog/new/',
  path: '/blog/new/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminBookingsIdPageRoute = adminBookingsIdPageRouteImport.update({
  id: '/bookings/$id/',
  path: '/bookings/$id/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminCampaignsIdPageRoute = adminCampaignsIdPageRouteImport.update({
  id: '/campaigns/$id/',
  path: '/campaigns/$id/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminOrdersIdPageRoute = adminOrdersIdPageRouteImport.update({
  id: '/orders/$id/',
  path: '/orders/$id/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminPlatformStoresPageRoute = adminPlatformStoresPageRouteImport.update({
  id: '/platform/stores/',
  path: '/platform/stores/',
  getParentRoute: () => adminRouteRoute,
} as any)
const adminProductsCategoriesPageRoute =
  adminProductsCategoriesPageRouteImport.update({
    id: '/products/categories/',
    path: '/products/categories/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminWorkersIdPageRoute = adminWorkersIdPageRouteImport.update({
  id: '/workers/$id/',
  path: '/workers/$id/',
  getParentRoute: () => adminRouteRoute,
} as any)
const authenticationauthAcceptInvitePageRoute =
  authenticationauthAcceptInvitePageRouteImport.update({
    id: '/(authentication)/(auth)/accept-invite/',
    path: '/accept-invite/',
    getParentRoute: () => rootRouteImport,
  } as any)
const authenticationauthForgotPasswordPageRoute =
  authenticationauthForgotPasswordPageRouteImport.update({
    id: '/(authentication)/(auth)/forgot-password/',
    path: '/forgot-password/',
    getParentRoute: () => rootRouteImport,
  } as any)
const authenticationauthResetPasswordPageRoute =
  authenticationauthResetPasswordPageRouteImport.update({
    id: '/(authentication)/(auth)/reset-password/',
    path: '/reset-password/',
    getParentRoute: () => rootRouteImport,
  } as any)
const authenticationauthSigninPageRoute =
  authenticationauthSigninPageRouteImport.update({
    id: '/(authentication)/(auth)/signin/',
    path: '/signin/',
    getParentRoute: () => rootRouteImport,
  } as any)
const authenticationauthSignupPageRoute =
  authenticationauthSignupPageRouteImport.update({
    id: '/(authentication)/(auth)/signup/',
    path: '/signup/',
    getParentRoute: () => rootRouteImport,
  } as any)
const authenticationerrorPagesError404PageRoute =
  authenticationerrorPagesError404PageRouteImport.update({
    id: '/(authentication)/(error-pages)/error-404/',
    path: '/error-404/',
    getParentRoute: () => rootRouteImport,
  } as any)
const adminothersPageschartBarChartPageRoute =
  adminothersPageschartBarChartPageRouteImport.update({
    id: '/(others-pages)/(chart)/bar-chart/',
    path: '/bar-chart/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPageschartLineChartPageRoute =
  adminothersPageschartLineChartPageRouteImport.update({
    id: '/(others-pages)/(chart)/line-chart/',
    path: '/line-chart/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPagesformsFormElementsPageRoute =
  adminothersPagesformsFormElementsPageRouteImport.update({
    id: '/(others-pages)/(forms)/form-elements/',
    path: '/form-elements/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPagestablesBasicTablesPageRoute =
  adminothersPagestablesBasicTablesPageRouteImport.update({
    id: '/(others-pages)/(tables)/basic-tables/',
    path: '/basic-tables/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPagesuiElementsAlertsPageRoute =
  adminothersPagesuiElementsAlertsPageRouteImport.update({
    id: '/(others-pages)/(ui-elements)/alerts/',
    path: '/alerts/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPagesuiElementsAvatarsPageRoute =
  adminothersPagesuiElementsAvatarsPageRouteImport.update({
    id: '/(others-pages)/(ui-elements)/avatars/',
    path: '/avatars/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPagesuiElementsBadgePageRoute =
  adminothersPagesuiElementsBadgePageRouteImport.update({
    id: '/(others-pages)/(ui-elements)/badge/',
    path: '/badge/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPagesuiElementsButtonsPageRoute =
  adminothersPagesuiElementsButtonsPageRouteImport.update({
    id: '/(others-pages)/(ui-elements)/buttons/',
    path: '/buttons/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPagesuiElementsImagesPageRoute =
  adminothersPagesuiElementsImagesPageRouteImport.update({
    id: '/(others-pages)/(ui-elements)/images/',
    path: '/images/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPagesuiElementsModalsPageRoute =
  adminothersPagesuiElementsModalsPageRouteImport.update({
    id: '/(others-pages)/(ui-elements)/modals/',
    path: '/modals/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const adminothersPagesuiElementsVideosPageRoute =
  adminothersPagesuiElementsVideosPageRouteImport.update({
    id: '/(others-pages)/(ui-elements)/videos/',
    path: '/videos/',
    getParentRoute: () => adminRouteRoute,
  } as any)
const authenticationauthPlatformSigninPageRoute =
  authenticationauthPlatformSigninPageRouteImport.update({
    id: '/(authentication)/(auth)/platform/signin/',
    path: '/platform/signin/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/landing': typeof publicLandingRouteRouteWithChildren
  '/': typeof adminPageRoute
  '/403/': typeof admin403PageRoute
  '/admin-profile/': typeof adminAdminProfilePageRoute
  '/admin-reports/': typeof adminAdminReportsPageRoute
  '/ai-ops/': typeof adminAiOpsPageRoute
  '/analytics/': typeof adminAnalyticsPageRoute
  '/areas/': typeof adminAreasPageRoute
  '/audit-log/': typeof adminAuditLogPageRoute
  '/billing/': typeof adminBillingPageRoute
  '/blog/': typeof adminBlogPageRoute
  '/bookings/': typeof adminBookingsPageRoute
  '/campaigns/': typeof adminCampaignsPageRoute
  '/carousel/': typeof adminCarouselPageRoute
  '/cms/': typeof adminCmsPageRoute
  '/contacts/': typeof adminContactsPageRoute
  '/crm/': typeof adminCrmPageRoute
  '/discounts/': typeof adminDiscountsPageRoute
  '/hero-slides/': typeof adminHeroSlidesPageRoute
  '/image-library/': typeof adminImageLibraryPageRoute
  '/inventory/': typeof adminInventoryPageRoute
  '/items/': typeof adminItemsPageRoute
  '/live-workforce/': typeof adminLiveWorkforcePageRoute
  '/locations/': typeof adminLocationsPageRoute
  '/loyalty/': typeof adminLoyaltyPageRoute
  '/messages/': typeof adminMessagesPageRoute
  '/newsletter/': typeof adminNewsletterPageRoute
  '/notifications/': typeof adminNotificationsPageRoute
  '/orders/': typeof adminOrdersPageRoute
  '/packages/': typeof adminPackagesPageRoute
  '/payments/': typeof adminPaymentsPageRoute
  '/permissions/': typeof adminPermissionsPageRoute
  '/product-campaigns/': typeof adminProductCampaignsPageRoute
  '/products/': typeof adminProductsPageRoute
  '/promo-tiles/': typeof adminPromoTilesPageRoute
  '/quotes/': typeof adminQuotesPageRoute
  '/referrals/': typeof adminReferralsPageRoute
  '/reports/': typeof adminReportsPageRoute
  '/reviews/': typeof adminReviewsPageRoute
  '/schedule/': typeof adminSchedulePageRoute
  '/settings/': typeof adminSettingsPageRoute
  '/site/': typeof adminSitePageRoute
  '/system-health/': typeof adminSystemHealthPageRoute
  '/testimonials/': typeof adminTestimonialsPageRoute
  '/users/': typeof adminUsersPageRoute
  '/workers/': typeof adminWorkersPageRoute
  '/auth/': typeof authenticationAuthPageRoute
  '/landing/': typeof publicLandingPageRoute
  '/dashboard/': typeof userDashboardPageRoute
  '/profile/': typeof userProfilePageRoute
  '/analytics/ecommerce': typeof adminAnalyticsEcommerceRoute
  '/auth/layout': typeof authenticationAuthLayoutRoute
  '/auth/logout': typeof authenticationAuthLogoutRoute
  '/blank/': typeof adminothersPagesBlankPageRoute
  '/calendar/': typeof adminothersPagesCalendarPageRoute
  '/blog/$id/': typeof adminBlogIdPageRoute
  '/blog/new/': typeof adminBlogNewPageRoute
  '/bookings/$id/': typeof adminBookingsIdPageRoute
  '/campaigns/$id/': typeof adminCampaignsIdPageRoute
  '/orders/$id/': typeof adminOrdersIdPageRoute
  '/platform/stores/': typeof adminPlatformStoresPageRoute
  '/products/categories/': typeof adminProductsCategoriesPageRoute
  '/workers/$id/': typeof adminWorkersIdPageRoute
  '/accept-invite/': typeof authenticationauthAcceptInvitePageRoute
  '/forgot-password/': typeof authenticationauthForgotPasswordPageRoute
  '/reset-password/': typeof authenticationauthResetPasswordPageRoute
  '/signin/': typeof authenticationauthSigninPageRoute
  '/signup/': typeof authenticationauthSignupPageRoute
  '/error-404/': typeof authenticationerrorPagesError404PageRoute
  '/bar-chart/': typeof adminothersPageschartBarChartPageRoute
  '/line-chart/': typeof adminothersPageschartLineChartPageRoute
  '/form-elements/': typeof adminothersPagesformsFormElementsPageRoute
  '/basic-tables/': typeof adminothersPagestablesBasicTablesPageRoute
  '/alerts/': typeof adminothersPagesuiElementsAlertsPageRoute
  '/avatars/': typeof adminothersPagesuiElementsAvatarsPageRoute
  '/badge/': typeof adminothersPagesuiElementsBadgePageRoute
  '/buttons/': typeof adminothersPagesuiElementsButtonsPageRoute
  '/images/': typeof adminothersPagesuiElementsImagesPageRoute
  '/modals/': typeof adminothersPagesuiElementsModalsPageRoute
  '/videos/': typeof adminothersPagesuiElementsVideosPageRoute
  '/platform/signin/': typeof authenticationauthPlatformSigninPageRoute
}
export interface FileRoutesByTo {
  '/': typeof adminPageRoute
  '/403': typeof admin403PageRoute
  '/admin-profile': typeof adminAdminProfilePageRoute
  '/admin-reports': typeof adminAdminReportsPageRoute
  '/ai-ops': typeof adminAiOpsPageRoute
  '/analytics': typeof adminAnalyticsPageRoute
  '/areas': typeof adminAreasPageRoute
  '/audit-log': typeof adminAuditLogPageRoute
  '/billing': typeof adminBillingPageRoute
  '/blog': typeof adminBlogPageRoute
  '/bookings': typeof adminBookingsPageRoute
  '/campaigns': typeof adminCampaignsPageRoute
  '/carousel': typeof adminCarouselPageRoute
  '/cms': typeof adminCmsPageRoute
  '/contacts': typeof adminContactsPageRoute
  '/crm': typeof adminCrmPageRoute
  '/discounts': typeof adminDiscountsPageRoute
  '/hero-slides': typeof adminHeroSlidesPageRoute
  '/image-library': typeof adminImageLibraryPageRoute
  '/inventory': typeof adminInventoryPageRoute
  '/items': typeof adminItemsPageRoute
  '/live-workforce': typeof adminLiveWorkforcePageRoute
  '/locations': typeof adminLocationsPageRoute
  '/loyalty': typeof adminLoyaltyPageRoute
  '/messages': typeof adminMessagesPageRoute
  '/newsletter': typeof adminNewsletterPageRoute
  '/notifications': typeof adminNotificationsPageRoute
  '/orders': typeof adminOrdersPageRoute
  '/packages': typeof adminPackagesPageRoute
  '/payments': typeof adminPaymentsPageRoute
  '/permissions': typeof adminPermissionsPageRoute
  '/product-campaigns': typeof adminProductCampaignsPageRoute
  '/products': typeof adminProductsPageRoute
  '/promo-tiles': typeof adminPromoTilesPageRoute
  '/quotes': typeof adminQuotesPageRoute
  '/referrals': typeof adminReferralsPageRoute
  '/reports': typeof adminReportsPageRoute
  '/reviews': typeof adminReviewsPageRoute
  '/schedule': typeof adminSchedulePageRoute
  '/settings': typeof adminSettingsPageRoute
  '/site': typeof adminSitePageRoute
  '/system-health': typeof adminSystemHealthPageRoute
  '/testimonials': typeof adminTestimonialsPageRoute
  '/users': typeof adminUsersPageRoute
  '/workers': typeof adminWorkersPageRoute
  '/auth': typeof authenticationAuthPageRoute
  '/landing': typeof publicLandingPageRoute
  '/dashboard': typeof userDashboardPageRoute
  '/profile': typeof userProfilePageRoute
  '/analytics/ecommerce': typeof adminAnalyticsEcommerceRoute
  '/auth/layout': typeof authenticationAuthLayoutRoute
  '/auth/logout': typeof authenticationAuthLogoutRoute
  '/blank': typeof adminothersPagesBlankPageRoute
  '/calendar': typeof adminothersPagesCalendarPageRoute
  '/blog/$id': typeof adminBlogIdPageRoute
  '/blog/new': typeof adminBlogNewPageRoute
  '/bookings/$id': typeof adminBookingsIdPageRoute
  '/campaigns/$id': typeof adminCampaignsIdPageRoute
  '/orders/$id': typeof adminOrdersIdPageRoute
  '/platform/stores': typeof adminPlatformStoresPageRoute
  '/products/categories': typeof adminProductsCategoriesPageRoute
  '/workers/$id': typeof adminWorkersIdPageRoute
  '/accept-invite': typeof authenticationauthAcceptInvitePageRoute
  '/forgot-password': typeof authenticationauthForgotPasswordPageRoute
  '/reset-password': typeof authenticationauthResetPasswordPageRoute
  '/signin': typeof authenticationauthSigninPageRoute
  '/signup': typeof authenticationauthSignupPageRoute
  '/error-404': typeof authenticationerrorPagesError404PageRoute
  '/bar-chart': typeof adminothersPageschartBarChartPageRoute
  '/line-chart': typeof adminothersPageschartLineChartPageRoute
  '/form-elements': typeof adminothersPagesformsFormElementsPageRoute
  '/basic-tables': typeof adminothersPagestablesBasicTablesPageRoute
  '/alerts': typeof adminothersPagesuiElementsAlertsPageRoute
  '/avatars': typeof adminothersPagesuiElementsAvatarsPageRoute
  '/badge': typeof adminothersPagesuiElementsBadgePageRoute
  '/buttons': typeof adminothersPagesuiElementsButtonsPageRoute
  '/images': typeof adminothersPagesuiElementsImagesPageRoute
  '/modals': typeof adminothersPagesuiElementsModalsPageRoute
  '/videos': typeof adminothersPagesuiElementsVideosPageRoute
  '/platform/signin': typeof authenticationauthPlatformSigninPageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(admin)': typeof adminRouteRouteWithChildren
  '/(public)/landing': typeof publicLandingRouteRouteWithChildren
  '/(admin)/': typeof adminPageRoute
  '/(admin)/403/': typeof admin403PageRoute
  '/(admin)/admin-profile/': typeof adminAdminProfilePageRoute
  '/(admin)/admin-reports/': typeof adminAdminReportsPageRoute
  '/(admin)/ai-ops/': typeof adminAiOpsPageRoute
  '/(admin)/analytics/': typeof adminAnalyticsPageRoute
  '/(admin)/areas/': typeof adminAreasPageRoute
  '/(admin)/audit-log/': typeof adminAuditLogPageRoute
  '/(admin)/billing/': typeof adminBillingPageRoute
  '/(admin)/blog/': typeof adminBlogPageRoute
  '/(admin)/bookings/': typeof adminBookingsPageRoute
  '/(admin)/campaigns/': typeof adminCampaignsPageRoute
  '/(admin)/carousel/': typeof adminCarouselPageRoute
  '/(admin)/cms/': typeof adminCmsPageRoute
  '/(admin)/contacts/': typeof adminContactsPageRoute
  '/(admin)/crm/': typeof adminCrmPageRoute
  '/(admin)/discounts/': typeof adminDiscountsPageRoute
  '/(admin)/hero-slides/': typeof adminHeroSlidesPageRoute
  '/(admin)/image-library/': typeof adminImageLibraryPageRoute
  '/(admin)/inventory/': typeof adminInventoryPageRoute
  '/(admin)/items/': typeof adminItemsPageRoute
  '/(admin)/live-workforce/': typeof adminLiveWorkforcePageRoute
  '/(admin)/locations/': typeof adminLocationsPageRoute
  '/(admin)/loyalty/': typeof adminLoyaltyPageRoute
  '/(admin)/messages/': typeof adminMessagesPageRoute
  '/(admin)/newsletter/': typeof adminNewsletterPageRoute
  '/(admin)/notifications/': typeof adminNotificationsPageRoute
  '/(admin)/orders/': typeof adminOrdersPageRoute
  '/(admin)/packages/': typeof adminPackagesPageRoute
  '/(admin)/payments/': typeof adminPaymentsPageRoute
  '/(admin)/permissions/': typeof adminPermissionsPageRoute
  '/(admin)/product-campaigns/': typeof adminProductCampaignsPageRoute
  '/(admin)/products/': typeof adminProductsPageRoute
  '/(admin)/promo-tiles/': typeof adminPromoTilesPageRoute
  '/(admin)/quotes/': typeof adminQuotesPageRoute
  '/(admin)/referrals/': typeof adminReferralsPageRoute
  '/(admin)/reports/': typeof adminReportsPageRoute
  '/(admin)/reviews/': typeof adminReviewsPageRoute
  '/(admin)/schedule/': typeof adminSchedulePageRoute
  '/(admin)/settings/': typeof adminSettingsPageRoute
  '/(admin)/site/': typeof adminSitePageRoute
  '/(admin)/system-health/': typeof adminSystemHealthPageRoute
  '/(admin)/testimonials/': typeof adminTestimonialsPageRoute
  '/(admin)/users/': typeof adminUsersPageRoute
  '/(admin)/workers/': typeof adminWorkersPageRoute
  '/(authentication)/auth/': typeof authenticationAuthPageRoute
  '/(public)/landing/': typeof publicLandingPageRoute
  '/(user)/dashboard/': typeof userDashboardPageRoute
  '/(user)/profile/': typeof userProfilePageRoute
  '/(admin)/analytics/ecommerce': typeof adminAnalyticsEcommerceRoute
  '/(authentication)/auth/layout': typeof authenticationAuthLayoutRoute
  '/(authentication)/auth/logout': typeof authenticationAuthLogoutRoute
  '/(admin)/(others-pages)/blank/': typeof adminothersPagesBlankPageRoute
  '/(admin)/(others-pages)/calendar/': typeof adminothersPagesCalendarPageRoute
  '/(admin)/blog/$id/': typeof adminBlogIdPageRoute
  '/(admin)/blog/new/': typeof adminBlogNewPageRoute
  '/(admin)/bookings/$id/': typeof adminBookingsIdPageRoute
  '/(admin)/campaigns/$id/': typeof adminCampaignsIdPageRoute
  '/(admin)/orders/$id/': typeof adminOrdersIdPageRoute
  '/(admin)/platform/stores/': typeof adminPlatformStoresPageRoute
  '/(admin)/products/categories/': typeof adminProductsCategoriesPageRoute
  '/(admin)/workers/$id/': typeof adminWorkersIdPageRoute
  '/(authentication)/(auth)/accept-invite/': typeof authenticationauthAcceptInvitePageRoute
  '/(authentication)/(auth)/forgot-password/': typeof authenticationauthForgotPasswordPageRoute
  '/(authentication)/(auth)/reset-password/': typeof authenticationauthResetPasswordPageRoute
  '/(authentication)/(auth)/signin/': typeof authenticationauthSigninPageRoute
  '/(authentication)/(auth)/signup/': typeof authenticationauthSignupPageRoute
  '/(authentication)/(error-pages)/error-404/': typeof authenticationerrorPagesError404PageRoute
  '/(admin)/(others-pages)/(chart)/bar-chart/': typeof adminothersPageschartBarChartPageRoute
  '/(admin)/(others-pages)/(chart)/line-chart/': typeof adminothersPageschartLineChartPageRoute
  '/(admin)/(others-pages)/(forms)/form-elements/': typeof adminothersPagesformsFormElementsPageRoute
  '/(admin)/(others-pages)/(tables)/basic-tables/': typeof adminothersPagestablesBasicTablesPageRoute
  '/(admin)/(others-pages)/(ui-elements)/alerts/': typeof adminothersPagesuiElementsAlertsPageRoute
  '/(admin)/(others-pages)/(ui-elements)/avatars/': typeof adminothersPagesuiElementsAvatarsPageRoute
  '/(admin)/(others-pages)/(ui-elements)/badge/': typeof adminothersPagesuiElementsBadgePageRoute
  '/(admin)/(others-pages)/(ui-elements)/buttons/': typeof adminothersPagesuiElementsButtonsPageRoute
  '/(admin)/(others-pages)/(ui-elements)/images/': typeof adminothersPagesuiElementsImagesPageRoute
  '/(admin)/(others-pages)/(ui-elements)/modals/': typeof adminothersPagesuiElementsModalsPageRoute
  '/(admin)/(others-pages)/(ui-elements)/videos/': typeof adminothersPagesuiElementsVideosPageRoute
  '/(authentication)/(auth)/platform/signin/': typeof authenticationauthPlatformSigninPageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/landing'
    | '/'
    | '/403/'
    | '/admin-profile/'
    | '/admin-reports/'
    | '/ai-ops/'
    | '/analytics/'
    | '/areas/'
    | '/audit-log/'
    | '/billing/'
    | '/blog/'
    | '/bookings/'
    | '/campaigns/'
    | '/carousel/'
    | '/cms/'
    | '/contacts/'
    | '/crm/'
    | '/discounts/'
    | '/hero-slides/'
    | '/image-library/'
    | '/inventory/'
    | '/items/'
    | '/live-workforce/'
    | '/locations/'
    | '/loyalty/'
    | '/messages/'
    | '/newsletter/'
    | '/notifications/'
    | '/orders/'
    | '/packages/'
    | '/payments/'
    | '/permissions/'
    | '/product-campaigns/'
    | '/products/'
    | '/promo-tiles/'
    | '/quotes/'
    | '/referrals/'
    | '/reports/'
    | '/reviews/'
    | '/schedule/'
    | '/settings/'
    | '/site/'
    | '/system-health/'
    | '/testimonials/'
    | '/users/'
    | '/workers/'
    | '/auth/'
    | '/landing/'
    | '/dashboard/'
    | '/profile/'
    | '/analytics/ecommerce'
    | '/auth/layout'
    | '/auth/logout'
    | '/blank/'
    | '/calendar/'
    | '/blog/$id/'
    | '/blog/new/'
    | '/bookings/$id/'
    | '/campaigns/$id/'
    | '/orders/$id/'
    | '/platform/stores/'
    | '/products/categories/'
    | '/workers/$id/'
    | '/accept-invite/'
    | '/forgot-password/'
    | '/reset-password/'
    | '/signin/'
    | '/signup/'
    | '/error-404/'
    | '/bar-chart/'
    | '/line-chart/'
    | '/form-elements/'
    | '/basic-tables/'
    | '/alerts/'
    | '/avatars/'
    | '/badge/'
    | '/buttons/'
    | '/images/'
    | '/modals/'
    | '/videos/'
    | '/platform/signin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/admin-profile'
    | '/admin-reports'
    | '/ai-ops'
    | '/analytics'
    | '/areas'
    | '/audit-log'
    | '/billing'
    | '/blog'
    | '/bookings'
    | '/campaigns'
    | '/carousel'
    | '/cms'
    | '/contacts'
    | '/crm'
    | '/discounts'
    | '/hero-slides'
    | '/image-library'
    | '/inventory'
    | '/items'
    | '/live-workforce'
    | '/locations'
    | '/loyalty'
    | '/messages'
    | '/newsletter'
    | '/notifications'
    | '/orders'
    | '/packages'
    | '/payments'
    | '/permissions'
    | '/product-campaigns'
    | '/products'
    | '/promo-tiles'
    | '/quotes'
    | '/referrals'
    | '/reports'
    | '/reviews'
    | '/schedule'
    | '/settings'
    | '/site'
    | '/system-health'
    | '/testimonials'
    | '/users'
    | '/workers'
    | '/auth'
    | '/landing'
    | '/dashboard'
    | '/profile'
    | '/analytics/ecommerce'
    | '/auth/layout'
    | '/auth/logout'
    | '/blank'
    | '/calendar'
    | '/blog/$id'
    | '/blog/new'
    | '/bookings/$id'
    | '/campaigns/$id'
    | '/orders/$id'
    | '/platform/stores'
    | '/products/categories'
    | '/workers/$id'
    | '/accept-invite'
    | '/forgot-password'
    | '/reset-password'
    | '/signin'
    | '/signup'
    | '/error-404'
    | '/bar-chart'
    | '/line-chart'
    | '/form-elements'
    | '/basic-tables'
    | '/alerts'
    | '/avatars'
    | '/badge'
    | '/buttons'
    | '/images'
    | '/modals'
    | '/videos'
    | '/platform/signin'
  id:
    | '__root__'
    | '/(admin)'
    | '/(public)/landing'
    | '/(admin)/'
    | '/(admin)/403/'
    | '/(admin)/admin-profile/'
    | '/(admin)/admin-reports/'
    | '/(admin)/ai-ops/'
    | '/(admin)/analytics/'
    | '/(admin)/areas/'
    | '/(admin)/audit-log/'
    | '/(admin)/billing/'
    | '/(admin)/blog/'
    | '/(admin)/bookings/'
    | '/(admin)/campaigns/'
    | '/(admin)/carousel/'
    | '/(admin)/cms/'
    | '/(admin)/contacts/'
    | '/(admin)/crm/'
    | '/(admin)/discounts/'
    | '/(admin)/hero-slides/'
    | '/(admin)/image-library/'
    | '/(admin)/inventory/'
    | '/(admin)/items/'
    | '/(admin)/live-workforce/'
    | '/(admin)/locations/'
    | '/(admin)/loyalty/'
    | '/(admin)/messages/'
    | '/(admin)/newsletter/'
    | '/(admin)/notifications/'
    | '/(admin)/orders/'
    | '/(admin)/packages/'
    | '/(admin)/payments/'
    | '/(admin)/permissions/'
    | '/(admin)/product-campaigns/'
    | '/(admin)/products/'
    | '/(admin)/promo-tiles/'
    | '/(admin)/quotes/'
    | '/(admin)/referrals/'
    | '/(admin)/reports/'
    | '/(admin)/reviews/'
    | '/(admin)/schedule/'
    | '/(admin)/settings/'
    | '/(admin)/site/'
    | '/(admin)/system-health/'
    | '/(admin)/testimonials/'
    | '/(admin)/users/'
    | '/(admin)/workers/'
    | '/(authentication)/auth/'
    | '/(public)/landing/'
    | '/(user)/dashboard/'
    | '/(user)/profile/'
    | '/(admin)/analytics/ecommerce'
    | '/(authentication)/auth/layout'
    | '/(authentication)/auth/logout'
    | '/(admin)/(others-pages)/blank/'
    | '/(admin)/(others-pages)/calendar/'
    | '/(admin)/blog/$id/'
    | '/(admin)/blog/new/'
    | '/(admin)/bookings/$id/'
    | '/(admin)/campaigns/$id/'
    | '/(admin)/orders/$id/'
    | '/(admin)/platform/stores/'
    | '/(admin)/products/categories/'
    | '/(admin)/workers/$id/'
    | '/(authentication)/(auth)/accept-invite/'
    | '/(authentication)/(auth)/forgot-password/'
    | '/(authentication)/(auth)/reset-password/'
    | '/(authentication)/(auth)/signin/'
    | '/(authentication)/(auth)/signup/'
    | '/(authentication)/(error-pages)/error-404/'
    | '/(admin)/(others-pages)/(chart)/bar-chart/'
    | '/(admin)/(others-pages)/(chart)/line-chart/'
    | '/(admin)/(others-pages)/(forms)/form-elements/'
    | '/(admin)/(others-pages)/(tables)/basic-tables/'
    | '/(admin)/(others-pages)/(ui-elements)/alerts/'
    | '/(admin)/(others-pages)/(ui-elements)/avatars/'
    | '/(admin)/(others-pages)/(ui-elements)/badge/'
    | '/(admin)/(others-pages)/(ui-elements)/buttons/'
    | '/(admin)/(others-pages)/(ui-elements)/images/'
    | '/(admin)/(others-pages)/(ui-elements)/modals/'
    | '/(admin)/(others-pages)/(ui-elements)/videos/'
    | '/(authentication)/(auth)/platform/signin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  adminRouteRoute: typeof adminRouteRouteWithChildren
  publicLandingRouteRoute: typeof publicLandingRouteRouteWithChildren
  authenticationAuthPageRoute: typeof authenticationAuthPageRoute
  userDashboardPageRoute: typeof userDashboardPageRoute
  userProfilePageRoute: typeof userProfilePageRoute
  authenticationAuthLayoutRoute: typeof authenticationAuthLayoutRoute
  authenticationAuthLogoutRoute: typeof authenticationAuthLogoutRoute
  authenticationauthAcceptInvitePageRoute: typeof authenticationauthAcceptInvitePageRoute
  authenticationauthForgotPasswordPageRoute: typeof authenticationauthForgotPasswordPageRoute
  authenticationauthResetPasswordPageRoute: typeof authenticationauthResetPasswordPageRoute
  authenticationauthSigninPageRoute: typeof authenticationauthSigninPageRoute
  authenticationauthSignupPageRoute: typeof authenticationauthSignupPageRoute
  authenticationerrorPagesError404PageRoute: typeof authenticationerrorPagesError404PageRoute
  authenticationauthPlatformSigninPageRoute: typeof authenticationauthPlatformSigninPageRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(admin)': {
      id: '/(admin)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof adminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/': {
      id: '/(admin)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof adminPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(public)/landing': {
      id: '/(public)/landing'
      path: '/landing'
      fullPath: '/landing'
      preLoaderRoute: typeof publicLandingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/403/': {
      id: '/(admin)/403/'
      path: '/403'
      fullPath: '/403/'
      preLoaderRoute: typeof admin403PageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/admin-profile/': {
      id: '/(admin)/admin-profile/'
      path: '/admin-profile'
      fullPath: '/admin-profile/'
      preLoaderRoute: typeof adminAdminProfilePageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/admin-reports/': {
      id: '/(admin)/admin-reports/'
      path: '/admin-reports'
      fullPath: '/admin-reports/'
      preLoaderRoute: typeof adminAdminReportsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/ai-ops/': {
      id: '/(admin)/ai-ops/'
      path: '/ai-ops'
      fullPath: '/ai-ops/'
      preLoaderRoute: typeof adminAiOpsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/analytics/': {
      id: '/(admin)/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof adminAnalyticsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/analytics/ecommerce': {
      id: '/(admin)/analytics/ecommerce'
      path: '/analytics/ecommerce'
      fullPath: '/analytics/ecommerce'
      preLoaderRoute: typeof adminAnalyticsEcommerceRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/areas/': {
      id: '/(admin)/areas/'
      path: '/areas'
      fullPath: '/areas/'
      preLoaderRoute: typeof adminAreasPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/audit-log/': {
      id: '/(admin)/audit-log/'
      path: '/audit-log'
      fullPath: '/audit-log/'
      preLoaderRoute: typeof adminAuditLogPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/billing/': {
      id: '/(admin)/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof adminBillingPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/blog/': {
      id: '/(admin)/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof adminBlogPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/bookings/': {
      id: '/(admin)/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof adminBookingsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/campaigns/': {
      id: '/(admin)/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof adminCampaignsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/carousel/': {
      id: '/(admin)/carousel/'
      path: '/carousel'
      fullPath: '/carousel/'
      preLoaderRoute: typeof adminCarouselPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/cms/': {
      id: '/(admin)/cms/'
      path: '/cms'
      fullPath: '/cms/'
      preLoaderRoute: typeof adminCmsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/contacts/': {
      id: '/(admin)/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof adminContactsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/crm/': {
      id: '/(admin)/crm/'
      path: '/crm'
      fullPath: '/crm/'
      preLoaderRoute: typeof adminCrmPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/discounts/': {
      id: '/(admin)/discounts/'
      path: '/discounts'
      fullPath: '/discounts/'
      preLoaderRoute: typeof adminDiscountsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/hero-slides/': {
      id: '/(admin)/hero-slides/'
      path: '/hero-slides'
      fullPath: '/hero-slides/'
      preLoaderRoute: typeof adminHeroSlidesPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/image-library/': {
      id: '/(admin)/image-library/'
      path: '/image-library'
      fullPath: '/image-library/'
      preLoaderRoute: typeof adminImageLibraryPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/inventory/': {
      id: '/(admin)/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof adminInventoryPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/items/': {
      id: '/(admin)/items/'
      path: '/items'
      fullPath: '/items/'
      preLoaderRoute: typeof adminItemsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/live-workforce/': {
      id: '/(admin)/live-workforce/'
      path: '/live-workforce'
      fullPath: '/live-workforce/'
      preLoaderRoute: typeof adminLiveWorkforcePageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/locations/': {
      id: '/(admin)/locations/'
      path: '/locations'
      fullPath: '/locations/'
      preLoaderRoute: typeof adminLocationsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/loyalty/': {
      id: '/(admin)/loyalty/'
      path: '/loyalty'
      fullPath: '/loyalty/'
      preLoaderRoute: typeof adminLoyaltyPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/messages/': {
      id: '/(admin)/messages/'
      path: '/messages'
      fullPath: '/messages/'
      preLoaderRoute: typeof adminMessagesPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/newsletter/': {
      id: '/(admin)/newsletter/'
      path: '/newsletter'
      fullPath: '/newsletter/'
      preLoaderRoute: typeof adminNewsletterPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/notifications/': {
      id: '/(admin)/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof adminNotificationsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/orders/': {
      id: '/(admin)/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof adminOrdersPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/packages/': {
      id: '/(admin)/packages/'
      path: '/packages'
      fullPath: '/packages/'
      preLoaderRoute: typeof adminPackagesPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/payments/': {
      id: '/(admin)/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof adminPaymentsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/permissions/': {
      id: '/(admin)/permissions/'
      path: '/permissions'
      fullPath: '/permissions/'
      preLoaderRoute: typeof adminPermissionsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/product-campaigns/': {
      id: '/(admin)/product-campaigns/'
      path: '/product-campaigns'
      fullPath: '/product-campaigns/'
      preLoaderRoute: typeof adminProductCampaignsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/products/': {
      id: '/(admin)/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof adminProductsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/promo-tiles/': {
      id: '/(admin)/promo-tiles/'
      path: '/promo-tiles'
      fullPath: '/promo-tiles/'
      preLoaderRoute: typeof adminPromoTilesPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/quotes/': {
      id: '/(admin)/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof adminQuotesPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/referrals/': {
      id: '/(admin)/referrals/'
      path: '/referrals'
      fullPath: '/referrals/'
      preLoaderRoute: typeof adminReferralsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/reports/': {
      id: '/(admin)/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof adminReportsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/reviews/': {
      id: '/(admin)/reviews/'
      path: '/reviews'
      fullPath: '/reviews/'
      preLoaderRoute: typeof adminReviewsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/schedule/': {
      id: '/(admin)/schedule/'
      path: '/schedule'
      fullPath: '/schedule/'
      preLoaderRoute: typeof adminSchedulePageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/settings/': {
      id: '/(admin)/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof adminSettingsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/site/': {
      id: '/(admin)/site/'
      path: '/site'
      fullPath: '/site/'
      preLoaderRoute: typeof adminSitePageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/system-health/': {
      id: '/(admin)/system-health/'
      path: '/system-health'
      fullPath: '/system-health/'
      preLoaderRoute: typeof adminSystemHealthPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/testimonials/': {
      id: '/(admin)/testimonials/'
      path: '/testimonials'
      fullPath: '/testimonials/'
      preLoaderRoute: typeof adminTestimonialsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/users/': {
      id: '/(admin)/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof adminUsersPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/workers/': {
      id: '/(admin)/workers/'
      path: '/workers'
      fullPath: '/workers/'
      preLoaderRoute: typeof adminWorkersPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(authentication)/auth/': {
      id: '/(authentication)/auth/'
      path: '/auth'
      fullPath: '/auth/'
      preLoaderRoute: typeof authenticationAuthPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(authentication)/auth/layout': {
      id: '/(authentication)/auth/layout'
      path: '/auth/layout'
      fullPath: '/auth/layout'
      preLoaderRoute: typeof authenticationAuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(authentication)/auth/logout': {
      id: '/(authentication)/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof authenticationAuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/landing/': {
      id: '/(public)/landing/'
      path: '/'
      fullPath: '/landing/'
      preLoaderRoute: typeof publicLandingPageRouteImport
      parentRoute: typeof publicLandingRouteRoute
    }
    '/(user)/dashboard/': {
      id: '/(user)/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof userDashboardPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(user)/profile/': {
      id: '/(user)/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof userProfilePageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/(others-pages)/blank/': {
      id: '/(admin)/(others-pages)/blank/'
      path: '/blank'
      fullPath: '/blank/'
      preLoaderRoute: typeof adminothersPagesBlankPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/calendar/': {
      id: '/(admin)/(others-pages)/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof adminothersPagesCalendarPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/blog/$id/': {
      id: '/(admin)/blog/$id/'
      path: '/blog/$id'
      fullPath: '/blog/$id/'
      preLoaderRoute: typeof adminBlogIdPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/blog/new/': {
      id: '/(admin)/blog/new/'
      path: '/blog/new'
      fullPath: '/blog/new/'
      preLoaderRoute: typeof adminBlogNewPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/bookings/$id/': {
      id: '/(admin)/bookings/$id/'
      path: '/bookings/$id'
      fullPath: '/bookings/$id/'
      preLoaderRoute: typeof adminBookingsIdPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/campaigns/$id/': {
      id: '/(admin)/campaigns/$id/'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id/'
      preLoaderRoute: typeof adminCampaignsIdPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/orders/$id/': {
      id: '/(admin)/orders/$id/'
      path: '/orders/$id'
      fullPath: '/orders/$id/'
      preLoaderRoute: typeof adminOrdersIdPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/platform/stores/': {
      id: '/(admin)/platform/stores/'
      path: '/platform/stores'
      fullPath: '/platform/stores/'
      preLoaderRoute: typeof adminPlatformStoresPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/products/categories/': {
      id: '/(admin)/products/categories/'
      path: '/products/categories'
      fullPath: '/products/categories/'
      preLoaderRoute: typeof adminProductsCategoriesPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/workers/$id/': {
      id: '/(admin)/workers/$id/'
      path: '/workers/$id'
      fullPath: '/workers/$id/'
      preLoaderRoute: typeof adminWorkersIdPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(authentication)/(auth)/accept-invite/': {
      id: '/(authentication)/(auth)/accept-invite/'
      path: '/accept-invite'
      fullPath: '/accept-invite/'
      preLoaderRoute: typeof authenticationauthAcceptInvitePageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(authentication)/(auth)/forgot-password/': {
      id: '/(authentication)/(auth)/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof authenticationauthForgotPasswordPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(authentication)/(auth)/reset-password/': {
      id: '/(authentication)/(auth)/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof authenticationauthResetPasswordPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(authentication)/(auth)/signin/': {
      id: '/(authentication)/(auth)/signin/'
      path: '/signin'
      fullPath: '/signin/'
      preLoaderRoute: typeof authenticationauthSigninPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(authentication)/(auth)/signup/': {
      id: '/(authentication)/(auth)/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof authenticationauthSignupPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(authentication)/(error-pages)/error-404/': {
      id: '/(authentication)/(error-pages)/error-404/'
      path: '/error-404'
      fullPath: '/error-404/'
      preLoaderRoute: typeof authenticationerrorPagesError404PageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/(others-pages)/(chart)/bar-chart/': {
      id: '/(admin)/(others-pages)/(chart)/bar-chart/'
      path: '/bar-chart'
      fullPath: '/bar-chart/'
      preLoaderRoute: typeof adminothersPageschartBarChartPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/(chart)/line-chart/': {
      id: '/(admin)/(others-pages)/(chart)/line-chart/'
      path: '/line-chart'
      fullPath: '/line-chart/'
      preLoaderRoute: typeof adminothersPageschartLineChartPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/(forms)/form-elements/': {
      id: '/(admin)/(others-pages)/(forms)/form-elements/'
      path: '/form-elements'
      fullPath: '/form-elements/'
      preLoaderRoute: typeof adminothersPagesformsFormElementsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/(tables)/basic-tables/': {
      id: '/(admin)/(others-pages)/(tables)/basic-tables/'
      path: '/basic-tables'
      fullPath: '/basic-tables/'
      preLoaderRoute: typeof adminothersPagestablesBasicTablesPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/(ui-elements)/alerts/': {
      id: '/(admin)/(others-pages)/(ui-elements)/alerts/'
      path: '/alerts'
      fullPath: '/alerts/'
      preLoaderRoute: typeof adminothersPagesuiElementsAlertsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/(ui-elements)/avatars/': {
      id: '/(admin)/(others-pages)/(ui-elements)/avatars/'
      path: '/avatars'
      fullPath: '/avatars/'
      preLoaderRoute: typeof adminothersPagesuiElementsAvatarsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/(ui-elements)/badge/': {
      id: '/(admin)/(others-pages)/(ui-elements)/badge/'
      path: '/badge'
      fullPath: '/badge/'
      preLoaderRoute: typeof adminothersPagesuiElementsBadgePageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/(ui-elements)/buttons/': {
      id: '/(admin)/(others-pages)/(ui-elements)/buttons/'
      path: '/buttons'
      fullPath: '/buttons/'
      preLoaderRoute: typeof adminothersPagesuiElementsButtonsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/(ui-elements)/images/': {
      id: '/(admin)/(others-pages)/(ui-elements)/images/'
      path: '/images'
      fullPath: '/images/'
      preLoaderRoute: typeof adminothersPagesuiElementsImagesPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/(ui-elements)/modals/': {
      id: '/(admin)/(others-pages)/(ui-elements)/modals/'
      path: '/modals'
      fullPath: '/modals/'
      preLoaderRoute: typeof adminothersPagesuiElementsModalsPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(admin)/(others-pages)/(ui-elements)/videos/': {
      id: '/(admin)/(others-pages)/(ui-elements)/videos/'
      path: '/videos'
      fullPath: '/videos/'
      preLoaderRoute: typeof adminothersPagesuiElementsVideosPageRouteImport
      parentRoute: typeof adminRouteRoute
    }
    '/(authentication)/(auth)/platform/signin/': {
      id: '/(authentication)/(auth)/platform/signin/'
      path: '/platform/signin'
      fullPath: '/platform/signin/'
      preLoaderRoute: typeof authenticationauthPlatformSigninPageRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface adminRouteRouteChildren {
  adminPageRoute: typeof adminPageRoute
  admin403PageRoute: typeof admin403PageRoute
  adminAdminProfilePageRoute: typeof adminAdminProfilePageRoute
  adminAdminReportsPageRoute: typeof adminAdminReportsPageRoute
  adminAiOpsPageRoute: typeof adminAiOpsPageRoute
  adminAnalyticsPageRoute: typeof adminAnalyticsPageRoute
  adminAreasPageRoute: typeof adminAreasPageRoute
  adminAuditLogPageRoute: typeof adminAuditLogPageRoute
  adminBillingPageRoute: typeof adminBillingPageRoute
  adminBlogPageRoute: typeof adminBlogPageRoute
  adminBookingsPageRoute: typeof adminBookingsPageRoute
  adminCampaignsPageRoute: typeof adminCampaignsPageRoute
  adminCarouselPageRoute: typeof adminCarouselPageRoute
  adminCmsPageRoute: typeof adminCmsPageRoute
  adminContactsPageRoute: typeof adminContactsPageRoute
  adminCrmPageRoute: typeof adminCrmPageRoute
  adminDiscountsPageRoute: typeof adminDiscountsPageRoute
  adminHeroSlidesPageRoute: typeof adminHeroSlidesPageRoute
  adminImageLibraryPageRoute: typeof adminImageLibraryPageRoute
  adminInventoryPageRoute: typeof adminInventoryPageRoute
  adminItemsPageRoute: typeof adminItemsPageRoute
  adminLiveWorkforcePageRoute: typeof adminLiveWorkforcePageRoute
  adminLocationsPageRoute: typeof adminLocationsPageRoute
  adminLoyaltyPageRoute: typeof adminLoyaltyPageRoute
  adminMessagesPageRoute: typeof adminMessagesPageRoute
  adminNewsletterPageRoute: typeof adminNewsletterPageRoute
  adminNotificationsPageRoute: typeof adminNotificationsPageRoute
  adminOrdersPageRoute: typeof adminOrdersPageRoute
  adminPackagesPageRoute: typeof adminPackagesPageRoute
  adminPaymentsPageRoute: typeof adminPaymentsPageRoute
  adminPermissionsPageRoute: typeof adminPermissionsPageRoute
  adminProductCampaignsPageRoute: typeof adminProductCampaignsPageRoute
  adminProductsPageRoute: typeof adminProductsPageRoute
  adminPromoTilesPageRoute: typeof adminPromoTilesPageRoute
  adminQuotesPageRoute: typeof adminQuotesPageRoute
  adminReferralsPageRoute: typeof adminReferralsPageRoute
  adminReportsPageRoute: typeof adminReportsPageRoute
  adminReviewsPageRoute: typeof adminReviewsPageRoute
  adminSchedulePageRoute: typeof adminSchedulePageRoute
  adminSettingsPageRoute: typeof adminSettingsPageRoute
  adminSitePageRoute: typeof adminSitePageRoute
  adminSystemHealthPageRoute: typeof adminSystemHealthPageRoute
  adminTestimonialsPageRoute: typeof adminTestimonialsPageRoute
  adminUsersPageRoute: typeof adminUsersPageRoute
  adminWorkersPageRoute: typeof adminWorkersPageRoute
  adminAnalyticsEcommerceRoute: typeof adminAnalyticsEcommerceRoute
  adminothersPagesBlankPageRoute: typeof adminothersPagesBlankPageRoute
  adminothersPagesCalendarPageRoute: typeof adminothersPagesCalendarPageRoute
  adminBlogIdPageRoute: typeof adminBlogIdPageRoute
  adminBlogNewPageRoute: typeof adminBlogNewPageRoute
  adminBookingsIdPageRoute: typeof adminBookingsIdPageRoute
  adminCampaignsIdPageRoute: typeof adminCampaignsIdPageRoute
  adminOrdersIdPageRoute: typeof adminOrdersIdPageRoute
  adminPlatformStoresPageRoute: typeof adminPlatformStoresPageRoute
  adminProductsCategoriesPageRoute: typeof adminProductsCategoriesPageRoute
  adminWorkersIdPageRoute: typeof adminWorkersIdPageRoute
  adminothersPageschartBarChartPageRoute: typeof adminothersPageschartBarChartPageRoute
  adminothersPageschartLineChartPageRoute: typeof adminothersPageschartLineChartPageRoute
  adminothersPagesformsFormElementsPageRoute: typeof adminothersPagesformsFormElementsPageRoute
  adminothersPagestablesBasicTablesPageRoute: typeof adminothersPagestablesBasicTablesPageRoute
  adminothersPagesuiElementsAlertsPageRoute: typeof adminothersPagesuiElementsAlertsPageRoute
  adminothersPagesuiElementsAvatarsPageRoute: typeof adminothersPagesuiElementsAvatarsPageRoute
  adminothersPagesuiElementsBadgePageRoute: typeof adminothersPagesuiElementsBadgePageRoute
  adminothersPagesuiElementsButtonsPageRoute: typeof adminothersPagesuiElementsButtonsPageRoute
  adminothersPagesuiElementsImagesPageRoute: typeof adminothersPagesuiElementsImagesPageRoute
  adminothersPagesuiElementsModalsPageRoute: typeof adminothersPagesuiElementsModalsPageRoute
  adminothersPagesuiElementsVideosPageRoute: typeof adminothersPagesuiElementsVideosPageRoute
}

const adminRouteRouteChildren: adminRouteRouteChildren = {
  adminPageRoute: adminPageRoute,
  admin403PageRoute: admin403PageRoute,
  adminAdminProfilePageRoute: adminAdminProfilePageRoute,
  adminAdminReportsPageRoute: adminAdminReportsPageRoute,
  adminAiOpsPageRoute: adminAiOpsPageRoute,
  adminAnalyticsPageRoute: adminAnalyticsPageRoute,
  adminAreasPageRoute: adminAreasPageRoute,
  adminAuditLogPageRoute: adminAuditLogPageRoute,
  adminBillingPageRoute: adminBillingPageRoute,
  adminBlogPageRoute: adminBlogPageRoute,
  adminBookingsPageRoute: adminBookingsPageRoute,
  adminCampaignsPageRoute: adminCampaignsPageRoute,
  adminCarouselPageRoute: adminCarouselPageRoute,
  adminCmsPageRoute: adminCmsPageRoute,
  adminContactsPageRoute: adminContactsPageRoute,
  adminCrmPageRoute: adminCrmPageRoute,
  adminDiscountsPageRoute: adminDiscountsPageRoute,
  adminHeroSlidesPageRoute: adminHeroSlidesPageRoute,
  adminImageLibraryPageRoute: adminImageLibraryPageRoute,
  adminInventoryPageRoute: adminInventoryPageRoute,
  adminItemsPageRoute: adminItemsPageRoute,
  adminLiveWorkforcePageRoute: adminLiveWorkforcePageRoute,
  adminLocationsPageRoute: adminLocationsPageRoute,
  adminLoyaltyPageRoute: adminLoyaltyPageRoute,
  adminMessagesPageRoute: adminMessagesPageRoute,
  adminNewsletterPageRoute: adminNewsletterPageRoute,
  adminNotificationsPageRoute: adminNotificationsPageRoute,
  adminOrdersPageRoute: adminOrdersPageRoute,
  adminPackagesPageRoute: adminPackagesPageRoute,
  adminPaymentsPageRoute: adminPaymentsPageRoute,
  adminPermissionsPageRoute: adminPermissionsPageRoute,
  adminProductCampaignsPageRoute: adminProductCampaignsPageRoute,
  adminProductsPageRoute: adminProductsPageRoute,
  adminPromoTilesPageRoute: adminPromoTilesPageRoute,
  adminQuotesPageRoute: adminQuotesPageRoute,
  adminReferralsPageRoute: adminReferralsPageRoute,
  adminReportsPageRoute: adminReportsPageRoute,
  adminReviewsPageRoute: adminReviewsPageRoute,
  adminSchedulePageRoute: adminSchedulePageRoute,
  adminSettingsPageRoute: adminSettingsPageRoute,
  adminSitePageRoute: adminSitePageRoute,
  adminSystemHealthPageRoute: adminSystemHealthPageRoute,
  adminTestimonialsPageRoute: adminTestimonialsPageRoute,
  adminUsersPageRoute: adminUsersPageRoute,
  adminWorkersPageRoute: adminWorkersPageRoute,
  adminAnalyticsEcommerceRoute: adminAnalyticsEcommerceRoute,
  adminothersPagesBlankPageRoute: adminothersPagesBlankPageRoute,
  adminothersPagesCalendarPageRoute: adminothersPagesCalendarPageRoute,
  adminBlogIdPageRoute: adminBlogIdPageRoute,
  adminBlogNewPageRoute: adminBlogNewPageRoute,
  adminBookingsIdPageRoute: adminBookingsIdPageRoute,
  adminCampaignsIdPageRoute: adminCampaignsIdPageRoute,
  adminOrdersIdPageRoute: adminOrdersIdPageRoute,
  adminPlatformStoresPageRoute: adminPlatformStoresPageRoute,
  adminProductsCategoriesPageRoute: adminProductsCategoriesPageRoute,
  adminWorkersIdPageRoute: adminWorkersIdPageRoute,
  adminothersPageschartBarChartPageRoute:
    adminothersPageschartBarChartPageRoute,
  adminothersPageschartLineChartPageRoute:
    adminothersPageschartLineChartPageRoute,
  adminothersPagesformsFormElementsPageRoute:
    adminothersPagesformsFormElementsPageRoute,
  adminothersPagestablesBasicTablesPageRoute:
    adminothersPagestablesBasicTablesPageRoute,
  adminothersPagesuiElementsAlertsPageRoute:
    adminothersPagesuiElementsAlertsPageRoute,
  adminothersPagesuiElementsAvatarsPageRoute:
    adminothersPagesuiElementsAvatarsPageRoute,
  adminothersPagesuiElementsBadgePageRoute:
    adminothersPagesuiElementsBadgePageRoute,
  adminothersPagesuiElementsButtonsPageRoute:
    adminothersPagesuiElementsButtonsPageRoute,
  adminothersPagesuiElementsImagesPageRoute:
    adminothersPagesuiElementsImagesPageRoute,
  adminothersPagesuiElementsModalsPageRoute:
    adminothersPagesuiElementsModalsPageRoute,
  adminothersPagesuiElementsVideosPageRoute:
    adminothersPagesuiElementsVideosPageRoute,
}

const adminRouteRouteWithChildren = adminRouteRoute._addFileChildren(
  adminRouteRouteChildren,
)

interface publicLandingRouteRouteChildren {
  publicLandingPageRoute: typeof publicLandingPageRoute
}

const publicLandingRouteRouteChildren: publicLandingRouteRouteChildren = {
  publicLandingPageRoute: publicLandingPageRoute,
}

const publicLandingRouteRouteWithChildren =
  publicLandingRouteRoute._addFileChildren(publicLandingRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  adminRouteRoute: adminRouteRouteWithChildren,
  publicLandingRouteRoute: publicLandingRouteRouteWithChildren,
  authenticationAuthPageRoute: authenticationAuthPageRoute,
  userDashboardPageRoute: userDashboardPageRoute,
  userProfilePageRoute: userProfilePageRoute,
  authenticationAuthLayoutRoute: authenticationAuthLayoutRoute,
  authenticationAuthLogoutRoute: authenticationAuthLogoutRoute,
  authenticationauthAcceptInvitePageRoute:
    authenticationauthAcceptInvitePageRoute,
  authenticationauthForgotPasswordPageRoute:
    authenticationauthForgotPasswordPageRoute,
  authenticationauthResetPasswordPageRoute:
    authenticationauthResetPasswordPageRoute,
  authenticationauthSigninPageRoute: authenticationauthSigninPageRoute,
  authenticationauthSignupPageRoute: authenticationauthSignupPageRoute,
  authenticationerrorPagesError404PageRoute:
    authenticationerrorPagesError404PageRoute,
  authenticationauthPlatformSigninPageRoute:
    authenticationauthPlatformSigninPageRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
